import React from 'react';

interface HealthStatusIndicatorProps {
  status: 'generating' | 'offline' | 'faulty' | 'maintenance';
  healthScore?: number;
}

export const HealthStatusIndicator: React.FC<HealthStatusIndicatorProps> = ({ 
  status, 
  healthScore 
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'generating':
        return {
          icon: '✓',
          color: 'bg-green-100 text-green-800',
          label: 'Generating'
        };
      case 'offline':
        return {
          icon: '✗',
          color: 'bg-red-100 text-red-800',
          label: 'Offline'
        };
      case 'faulty':
        return {
          icon: '⚠',
          color: 'bg-yellow-100 text-yellow-800',
          label: 'Faulty'
        };
      case 'maintenance':
        return {
          icon: '🔧',
          color: 'bg-blue-100 text-blue-800',
          label: 'Maintenance'
        };
      default:
        return {
          icon: '?',
          color: 'bg-gray-100 text-gray-800',
          label: 'Unknown'
        };
    }
  };

  const config = getStatusConfig();

  return (
    <div className="flex items-center gap-2">
      <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
        {config.icon} {config.label}
      </span>
      {healthScore !== undefined && status === 'generating' && (
        <span className="text-xs text-gray-500">
          {healthScore.toFixed(1)}%
        </span>
      )}
    </div>
  );
};